export default __webpack_public_path__ + "static/media/swipe.fafa7564.gif";